import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; transform: scale(0.9); }
  to { opacity: 1; transform: scale(1); }
`;

const ComplimentSection = styled.div`
  text-align: center;
  padding: 40px 20px;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  margin: 30px auto;
  max-width: 800px;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
`;

const ComplimentTitle = styled.h2`
  font-size: 2.2em;
  color: #fff;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  margin-bottom: 20px;
`;

const ComplimentBtn = styled.button`
  padding: 15px 40px;
  font-size: 1.3em;
  background: linear-gradient(135deg, #f093fb, #f5576c);
  color: white;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  transition: all 0.3s;
  font-family: 'Comic Sans MS', cursive, sans-serif;
  font-weight: bold;
  margin-bottom: 20px;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 7px 20px rgba(0, 0, 0, 0.4);
  }
`;

const ComplimentDisplay = styled.div`
  font-size: 1.5em;
  color: #ffe066;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  padding: 20px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 15px;
  margin-top: 20px;
  min-height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${fadeIn} 0.5s;
`;

function ComplimentGenerator() {
  const [currentCompliment, setCurrentCompliment] = useState('');

  const compliments = [
    "Steven Frolke doesn't fact-check. Facts Steven-check. 🔍",
    "When Steven Frolke opens a bottle of wine, the cork apologizes for being in the way. 🍾",
    "Steven Frolke's cat doesn't have nine lives. It has one Steven-approved life, and that's enough. 😼",
    "Deadlines don't chase Steven Frolke. They wait politely for him to arrive. ⏰",
    "Steven Frolke can write a Pulitzer-winning article while wine tasting. Simultaneously. 🏆🍷",
    "When cats see Steven Frolke, they wonder if they're doing 'cat' correctly. 🐱",
    "Steven Frolke doesn't Google things. Google Stevens things. 🔎",
    "Wine becomes vintage just by being in the same room as Steven Frolke. 🍇",
    "Steven Frolke's interviews don't have questions. They have enlightenment opportunities. 📰",
    "Other journalists use spell-check. Steven Frolke invented correct spelling. ✍️",
    "When Steven Frolke says 'no comment,' it becomes the most quoted phrase of the year. 💬",
    "Cats don't knock things off tables when Steven is around. They know better. 🙀",
    "Steven Frolke can taste a wine's entire history in one sip. Including the vineyard's Wi-Fi password. 🍷",
    "Breaking news doesn't break until Steven Frolke decides it's broken enough. 📢",
    "Steven Frolke once interviewed himself. It won an award. 🎖️",
    "Other people have cats. Cats have Steven Frolke. 😸",
    "Steven Frolke's keyboard doesn't have a backspace key. It's never needed one. ⌨️",
    "When Steven Frolke enters a wine cellar, the bottles stand at attention. 🫡",
    "Truth and Steven Frolke are best friends. They have matching bracelets. 🤝",
    "Steven Frolke doesn't do journalism. Journalism does Steven Frolke. And feels honored. ✨",
    "Steven Frolke can declassify documents just by looking at them. Sternly. 📄",
    "Grapes grow faster when they know they might become Steven Frolke's wine. 🍇",
    "Steven Frolke's sources don't leak information. They volunteer it enthusiastically. 🗣️",
    "When Steven Frolke writes 'allegedly,' lawyers delete the word. It's unnecessary. ⚖️",
    "Cats invented purring to communicate with Steven Frolke. It was their best idea. 😻",
    "Steven Frolke doesn't need a wine opener. Bottles open themselves out of respect. 🍷",
    "The Associated Press checks their style guide against Steven Frolke's writing. 📚",
    "Steven Frolke once fact-checked Wikipedia. Wikipedia is still recovering. 💻",
    "When Steven Frolke whispers to cats, other cats take notes. 📝",
    "Red wine or white? Steven Frolke says yes. And is correct. 🍷",
    "Steven Frolke doesn't have unnamed sources. They're just waiting for his permission to be named. 🎙️",
    "Cats measure their lives in Steven Frolke visits, not years. 🐈",
    "Steven Frolke can taste whether a wine was bottled on a Tuesday. While blindfolded. 👁️",
    "Press credentials were invented to keep up with Steven Frolke. They're still trying. 🆔",
    "When Steven Frolke reviews wine, vineyards frame the review instead of awards. 🖼️",
    "Steven Frolke's articles don't go viral. They go legendary. 🚀",
    "Cats have a secret language. Steven Frolke is fluent. 😺",
    "Steven Frolke doesn't chase stories. Stories line up for him. Single file. 📰",
    "The only thing faster than Steven Frolke's reporting is his cats when they hear the can opener. 🥫",
    "Steven Frolke pairs wine with truth. It's always a perfect match. 🍷✅"
  ];

  const generateCompliment = () => {
    const randomIndex = Math.floor(Math.random() * compliments.length);
    setCurrentCompliment(compliments[randomIndex]);
  };

  return (
    <ComplimentSection>
      <ComplimentTitle>⚡ STEVEN FROLKE FACTS ⚡</ComplimentTitle>
      <ComplimentBtn onClick={generateCompliment}>
        💪 GET A STEVEN FACT 💪
      </ComplimentBtn>
      {currentCompliment && (
        <ComplimentDisplay>
          {currentCompliment}
        </ComplimentDisplay>
      )}
    </ComplimentSection>
  );
}

export default ComplimentGenerator;
